module.exports = __webpack_public_path__ + "static/img/广告片-品牌广告片（TVC）.128e86d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/广告片-品牌广告片（TVC）.png
// module id = awVw
// module chunks = 1